const URLParams = new URLSearchParams(window.location.search);
export const IS_ECO = URLParams.get('channel') === '1000000013';
/**
 * 巴西站点 https://project.aone.alibaba-inc.com/#viewIdentifier=1c46ee8637e0c978f115b6f7&openWorkitemIdentifier=79899715
 */
export const IS_BRAZIL = URLParams.get('channel') === '1000000097';
/**
 * us 站点
 * https://project.aone.alibaba-inc.com/#viewIdentifier=1c46ee8637e0c978f115b6f7&openWorkitemIdentifier=80638633
 */
export const IS_US_STATION = URLParams.get('channel') === '1000000140';
